module.exports = __webpack_public_path__ + "media/images/static/benefit/h2_merit4-94eea383941cd960661d8bb23103a4ae.png";